import { render } from "./package-total-info.vue?vue&type=template&id=5d55067b"
import script from "./package-total-info.vue?vue&type=script&lang=js"
export * from "./package-total-info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__